import { cn } from '../../utils/className';

interface MachineSelectionHeaderProps {
  open: boolean;
  selectedCount: number;
  onCancel: () => void;
}

/**
 * The bar under the search row while the list is in selection mode. It stays
 * mounted and unfolds, so the list glides down instead of jumping.
 */
export function MachineSelectionHeader({
  open,
  selectedCount,
  onCancel,
}: MachineSelectionHeaderProps) {
  return (
    <div
      inert={!open}
      className={cn(
        `grid shrink-0 transition-[grid-template-rows,opacity] duration-200
        ease-in-out motion-reduce:transition-none`,
        open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
      )}
    >
      <div className='min-h-0 overflow-hidden'>
        <div
          className='bg-surface-focus-support flex h-12 items-center
            justify-between px-4'
        >
          <p className='size-p2 text-secondary' aria-live='polite'>
            <span className='font-bold'>{selectedCount}</span>
            {selectedCount === 1 ? ' machine selected' : ' machines selected'}
          </p>
          <button
            type='button'
            onClick={onCancel}
            // A finger needs 44px. The padding gives it, the margin keeps the
            // text where the design puts it.
            className='size-p2 text-focus hover:text-focus-strong -mr-2 min-h-11
              cursor-pointer px-2 font-bold'
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
